import { Text } from '@cellula/react';
import { Icon } from '@components/icon.component';
import { FlexibleButtonHyperlinkModel } from '@services/flexible_component/mod';
import { theme } from '@services/theme.service/theme';
import { rem } from '@visiba/std';
import styled from 'styled-components';
import { FONT_VARIANT } from '../../constants';
import { Routeable } from './_flexible_identifier_routeable.component';

interface Props {
	component: FlexibleButtonHyperlinkModel;
}

const elements = {
	container: styled.div`
		margin: ${rem(8)} 0;
		display: flex;
		align-items: center;
		color: ${theme.hyperLinkDefault};
		transition: color 200ms ease;

		&:hover {
			color: ${theme.hyperLinkHover};
		}
	`,
	linkWrapper: styled.div`
		display: flex;
		align-items: center;
	`,
	icon: styled.span`
		margin-left: ${rem(10)};
	`,
};

export function FlexibleButtonHyperlink({ component }: Props): JSX.Element {
	return (
		<elements.container data-testid='FlexibleButtonHyperlink'>
			<Routeable
				data-testid='FlexibleButtonHyperlink'
				url={component.url}
				requiresAuthentication={component.requiresAuthentication}
				openWith={component.openUrlWith}
				sourceButtonId={component.id}
			>
				<elements.linkWrapper>
					<Text variant='bodyRegular'>{component.title}</Text>
					<elements.icon aria-hidden='true'>
						<Icon type='arrowRight' center />
					</elements.icon>
				</elements.linkWrapper>
			</Routeable>
		</elements.container>
	);
}
